import { render, staticRenderFns } from "./PerformanceChart.vue?vue&type=template&id=6966ea2a&scoped=true&"
import script from "./PerformanceChart.vue?vue&type=script&lang=js&"
export * from "./PerformanceChart.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceChart.vue?vue&type=style&index=0&id=6966ea2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6966ea2a",
  null
  
)

export default component.exports